import axios from 'axios';

const fetchHlsPlaylist = async (hash: string) => {
  const res = await axios.get(`/videoPlaylist/?hash=${hash}`);
  return res.data;
};

/**
 * "Deobfuscates" HLS playlist.
 */
export const getHlsPlaylist = async (hash: string): Promise<string> => {
  const playlist = await fetchHlsPlaylist(hash);

  // Unobfuscate the playlist file
  let videoPlaylist = playlist.split('').reverse().join('');

  // Add the origin to the `/enc.key` otherwise we will get a CORS error as it tries to look at Blob/enc.key
  const encKeyLoc = videoPlaylist.indexOf('/enc.key?hash=');

  if (encKeyLoc > -1) {
    videoPlaylist =
      videoPlaylist.slice(0, encKeyLoc) +
      window.location.origin +
      videoPlaylist.slice(encKeyLoc);

    // custom logic for ios (see VideoPlayer.tsx file)
    if (/iPad|iPhone|iPod/i.test((window as Window).navigator.userAgent)) {
      const base64 = `data:application/x-mpegURL;base64,${Buffer.from(
        videoPlaylist,
        'utf8',
      ).toString('base64')}`;

      return base64;
    }

    // Create object URL
    const uri = URL.createObjectURL(new Blob([videoPlaylist]));

    return uri;
  }

  throw new Error('Error retrieving HLS playlist.');
};
